import { getLuminance } from 'polished';

export function getContrastText(color) {
  return getLuminance(color) > 0.6 ? '#333' : '#fff';
}



// WEBPACK FOOTER //
// ./src/app/helpers/colors.js